export default "__VITE_ASSET__223d413e__"